var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:"field",tag:"component",attrs:{"field":_vm.field},on:{"action":_vm.onAction,"change":_vm.onChange,"load-formatter":function($event){return _vm.$emit('load-formatter', $event)}},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }